import React from "react";
import { withRouter } from "react-router-dom";
import Layout from "../layouts/Layout";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PendingInvoice from "./PendingInvoice";
import CompleteInvoice from "./CompleteInvoice";
import PaidInvoice from "./PaidInvoice";
import { primaryShade1, primaryShade4, red, white } from "../styles/color";
const styles = theme => ({
  media: {
    height: 0,
    paddingTop: "56.25%" // 16:9
  },
  actions: {
    display: "flex"
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest
    })
  },
  expandOpen: {
    transform: "rotate(0deg)"
  },
  avatar: {
    backgroundColor: red
  }
});
class InvoiceDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0
    };
  }
  handleChange = (event, value) => {
    this.setState({ value });
  };
  componentWillMount() {
    console.log(this.props);
  }
  render() {
    const { value } = this.state;
    const {
      pending,
      complete,
      isLoading,
      updateInvoice,
      allDeals,
      allCustomers,
      customersList,
      paidInvoices,
      unPaidInvoices,
      appBarName,
      handleRemoveDeal,
      user,
      currentUser,
      products,
      invoicePrintData,
      organisationId
    } = this.props;
    return (
      <Layout
        position="static"
        bottomNavigation={true}
        appBar
        appBarTitle={appBarName}
        appBarLeftIcon={true}
        appBarRightIcon={true}
        selectedValue={1}
      >
        <div
          style={{
            marginTop: "55px"
          }}
        >
          <Tabs
            TabIndicatorProps={{ style: { backgroundColor: primaryShade4 } }}
            value={value}
            onChange={this.handleChange}
            fullWidth
            style={{ backgroundColor: primaryShade1, color: white }}
          >
            <Tab
              label="PENDING"
              style={{
                backgroundColor: value === 0 ? primaryShade4 : primaryShade1
              }}
            />
            <hr />
            <Tab
              label="GENERATED"
              style={{
                backgroundColor: value === 2 ? primaryShade4 : primaryShade1
              }}
            />
            <hr />
            <Tab
              label="PAID"
              style={{
                backgroundColor: value === 4 ? primaryShade4 : primaryShade1
              }}
            />
          </Tabs>
          {value === 0 && (
            <PendingInvoice
              isLoading={isLoading}
              pending={pending}
              customersList={customersList}
              allDeals={allDeals}
              allInvoices={paidInvoices.concat(unPaidInvoices)}
            />
          )}
          {value === 2 && (
            <CompleteInvoice
              user={user}
              currentUser={currentUser}
              invoicePrintData={invoicePrintData.find(
                invData => invData.userId === user.uid
              )}
              allCustomers={allCustomers}
              products={products}
              complete={complete}
              allDeals={allDeals}
              customersList={customersList}
              unPaidInvoices={unPaidInvoices.filter(
                data => data.customerId === this.props.match.params.customerId
              )}
              allInvoices={paidInvoices.concat(unPaidInvoices)}
              updateInvoice={updateInvoice}
              handleRemoveDeal={handleRemoveDeal}
            />
          )}
          {value === 4 && (
            <PaidInvoice
              complete={complete}
              customersList={customersList}
              paidInvoices={paidInvoices.filter(
                data => data.customerId === this.props.match.params.customerId
              )}
            />
          )}
        </div>
      </Layout>
    );
  }
}
InvoiceDetails.propTypes = {
  classes: PropTypes.object.isRequired
};
export default withRouter(withStyles(styles)(InvoiceDetails));
